import type { SaleMemberKind } from './types';

export const ENTERPRISE_SALE_MEMBER_URL = '/bizmember/enterprise/license_index?fr=maiin_index';
export const SALE_MEMBER_OPPORTUNITY_URL =
  'https://maimai.cn/jobs/sale_member_opportunity?fr=002175c3d723c8e56032bc4463da80e7';
export const PERSONAL_SALE_MEMBER_ALERT =
  '抱歉，当前个人销售会员不支持在PC端操作拓客通，请升级为企业会员进行操作！\n相关业务请咨询：13521777652';

export type SaleMemberAction = { type: 'alert' } | { type: 'open'; url: string } | { type: 'generic'; url: string };

export function deriveSaleMemberKind(card: unknown): SaleMemberKind {
  if (card === null || typeof card !== 'object') {
    return 'none';
  }

  const { mem_id: memberId, mem_st: memberStatus } = card as { mem_id?: unknown; mem_st?: unknown };
  if (Number(memberStatus) === 1 && Number(memberId) === 8) {
    return 'personal';
  }
  if (Number(memberStatus) === 1 && Number(memberId) === 10) {
    return 'enterprise';
  }
  return 'none';
}

export function resolveSaleMemberAction(kind: SaleMemberKind): SaleMemberAction {
  if (kind === 'personal') {
    return { type: 'alert' };
  }
  if (kind === 'enterprise') {
    return { type: 'open', url: ENTERPRISE_SALE_MEMBER_URL };
  }
  return { type: 'generic', url: SALE_MEMBER_OPPORTUNITY_URL };
}
